export { default } from './BottomNavigation';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/BottomNavigation/index.js
// module id = 786
// module chunks = 121